import { render, staticRenderFns } from "./gift.vue?vue&type=template&id=6674422e&scoped=true"
import script from "./gift.vue?vue&type=script&lang=js"
export * from "./gift.vue?vue&type=script&lang=js"
import style0 from "./gift.vue?vue&type=style&index=0&id=6674422e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!D:\\work\\dys\\duyisheng-admin-ui\\node_modules\\vue-loader\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6674422e",
  null
  
)

export default component.exports